module.exports = __webpack_public_path__ + "static/media/react-logo.6acf2796.png";